var _style, _path, _line, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBasket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 28.35 28.35",
    style: {
      enableBackground: "new 0 0 28.35 28.35"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t\r\n\t\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:none;stroke:#000000;stroke-width:1.5001;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3.54,11.85h21.34c0.41,0,0.74,0.31,0.74,0.69v1.94c0,0.38-0.34,0.69-0.74,0.69h-1.73l0.18,0.02l-1.44,7.82 c-0.13,0.71-0.45,1.1-1.28,1.1h-6.39H7.65c-0.73,0-0.96-0.3-1.08-0.97L5.09,15.2l0.12-0.02H3.54c-0.41,0-0.74-0.31-0.74-0.69v-1.94 C2.8,12.16,3.13,11.85,3.54,11.85z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 5.21,
    y1: 15.17,
    x2: 14.27,
    y2: 15.17
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.95,11.99V9.38c0-2.83,2.17-5.15,4.82-5.15h2.99c2.65,0,4.82,2.32,4.82,5.15v4.52"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasket);
export default __webpack_public_path__ + "static/media/basket.b263b43d63d746e20a7effbe27768533.svg";
export { ForwardRef as ReactComponent };